module.exports = __webpack_public_path__ + "static/media/qrmi.e8d59821.png";